<template>
   <div class="">
    <div v-if="!data.accountId">{{data.date}}</div>
    <p v-if="data.accountId" style="margin-bottom: 0; font-weight: bold; font-size: 20px;"> {{ $t('text.clickButtons.vouchersBy') }}  {{data.sentBy}}</p>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    createVoucherArr: function(e, v) {
        this.$eventHub.$emit("voucherCheck", e, v);
    }
  },
};

</script>